// extracted by mini-css-extract-plugin
export default {"editButton":"payRollUpload_editButton__YWGgb","TableBody":"payRollUpload_TableBody__R6nsR","deleteButton":"payRollUpload_deleteButton__lylwC"};